import { Pipe, PipeTransform } from '@angular/core';
import type { CardsThatLayoutOntoPaper } from '../../../models/menu/section/cards-that-layout-onto-paper';

@Pipe({
  name: 'nonPerforatedBleedBorderInInches',
  standalone: false
})
export class NonPerforatedBleedBorderInInchesPipe implements PipeTransform {
  transform(cardsThatLayoutOntoPaper: CardsThatLayoutOntoPaper | null): number {
    return cardsThatLayoutOntoPaper?.nonPerforatedBleedBorderInInches() ?? 0;
  }
}
